import request from '@/utils/request'
/**
* @fileOverview 奖项管理
*/

/**
* @description 奖项列表
*/
export function awards(params) {
  return request({
    url: '/awards',
    method: 'get',
    params
  })
}

/**
  * @description 创建奖项
  * @param {string} data.title 名称
  * @param {string} data.short 简称
  * @param {string} data.sign_start_date 报名开始时间
  * @param {string} data.sign_end_date 报名结束时间
  * @param {string} data.nomination_start_date 复评缴费开始时间
  * @param {string} data.nomination_end_date 复评缴费结束时间
  * @param {string} data.pay_start_date 获奖者服务缴费开始时间
  * @param {string} data.pay_end_date 获奖者服务缴费结束时间
  * @param {string} data.amount 复评费用
  */
export function createAwards(data) {
  return request({
    url: '/awards',
    method: 'post',
    data
  })
}

/**
* @description 编辑奖项
* @param {string} data.title 名称
* @param {string} data.short 简称
* @param {string} data.sign_start_date 报名开始时间
* @param {string} data.sign_end_date 报名结束时间
* @param {string} data.nomination_start_date 复评缴费开始时间
* @param {string} data.nomination_end_date 复评缴费结束时间
* @param {string} data.pay_start_date 获奖者服务缴费开始时间
* @param {string} data.pay_end_date 获奖者服务缴费结束时间
* @param {string} data.amount 复评费用
*/
export function editAwards(id, data) {
  return request({
    url: `/awards/${id}`,
    method: 'put',
    data
  })
}
